import { c as _c } from "react/compiler-runtime";
type OpenCodeIconProps = {
  size?: number | string;
  className?: string;
};
export function OpenCodeIcon(t0) {
  const $ = _c(5);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "1em" : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <path d="M24 32H8V16H24V32Z" fill="#4B4646" />;
    t3 = <path d="M24 8H8V32H24V8ZM32 40H0V0H32V40Z" fill="#F1ECEC" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== className || $[3] !== size) {
    t4 = <svg width={size} height={size} viewBox="0 0 32 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>{t2}{t3}</svg>;
    $[2] = className;
    $[3] = size;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}